import { useNavigate } from "react-router-dom";

import { useRandomSigninBackgroundImage } from "@/Helpers/randomBackgroundImage";
import { AuthenticationResetPassword } from "./CustomComponents/AuthenticationResetPassword";
import { AuthenticationScreenContainer } from "./CustomComponents/AuthenticationScreenContainer";

function ResetPasswordScreen() {
  const navigate = useNavigate();
  const backgroundImage = useRandomSigninBackgroundImage();

  return (
    <AuthenticationScreenContainer imageUrl={backgroundImage}>
      <AuthenticationResetPassword
        onBackToSignIn={() => navigate("/sign-in")}
      />
    </AuthenticationScreenContainer>
  );
}
export default ResetPasswordScreen;
